import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { IUserGroup } from 'bets.oddprovider.lib.common.ts/models'
import { ApiResponseGetListData } from 'fwork-jsts-common/src/api'
import { IApiClientResult } from 'fwork-jsts-common/src/apiClient'
import { IDefaultAction, IDefaultState } from 'fwork.react.apptemplate'
import { FilterQuery } from 'mongoose'
import axios from '../../apiClient/axios'
import { UserGroupsApiClient } from '../../apiClient/userGroups'

export interface IUserGroupsAction extends IDefaultAction {
  payload?: IUserGroup[],
}

export interface IUserGroupsState extends IDefaultState {
  payload?: IUserGroup[],
}

const initState: IUserGroupsState = {}

export const userGroupsStateLoadFromApi = createAsyncThunk(
  'userGroupsStateLoadFromApi',
  async (arg: {
    where?: FilterQuery<IUserGroup>,
    onSuccess?: () => void,
    onError?: (msg?: string) => void,
    onFinally?: () => void
  }) => {
    const apiResult: IApiClientResult<ApiResponseGetListData<IUserGroup>> = await new UserGroupsApiClient(axios).get({
      where: arg.where,
      sort: { name: 1 }
    })

    if (apiResult.success) {
      if (arg.onSuccess)
        arg.onSuccess()
    }
    else if (arg.onError)
      arg.onError(apiResult.msg)

    if (arg.onFinally)
      arg.onFinally()
    return apiResult
  }
)

export const userGroupsSlice = createSlice({
  name: 'userGroupsSlice',
  initialState: initState,
  reducers: {
    clear: (state) => {
      state.payload = []
    }
  },
  extraReducers: (builder) => {
    builder.addCase(userGroupsStateLoadFromApi.pending, (state) => {
      if (!state.options)
        state.options = {}
      state.options.loading = true
    })
    builder.addCase(userGroupsStateLoadFromApi.fulfilled, (state, response) => {
      if (state.options)
        state.options.loading = false
      state.payload = response.payload.data?.payload
    })
    builder.addCase(userGroupsStateLoadFromApi.rejected, (state) => {
      if (state.options)
        state.options.loading = false
    })
  }
})

export const { clear: clearUserGroups } = userGroupsSlice.actions
export default userGroupsSlice.reducer